import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import HeroVideo from "../components/HeroVideo";
import Logo from "../components/Logo";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { useLang } from "../context/LangContext";
import { useAuth } from "../context/AuthContext";
import { useEffect } from "react";

export default function Welcome() {
  const { t } = useLang();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/home", { replace: true });
  }, [user, navigate]);

  return (
    <div className="app-shell text-brand-cream">
      <HeroVideo height="min-h-[100dvh]">
        <div className="flex items-start justify-between px-6 pt-6 absolute top-0 inset-x-0">
          <Logo tone="cream" size="md" />
          <LanguageSwitcher tone="cream" />
        </div>

        <div className="px-6 pb-10 stagger">
          <p
            className="text-[10px] tracking-[0.45em] uppercase font-bold text-brand-gold mb-4"
            data-testid="welcome-kicker"
          >
            {t("welcome_kicker")} · {t("brand_tagline")}
          </p>
          <h1 className="font-serif text-5xl sm:text-6xl leading-[1.02] text-brand-cream max-w-[18ch]">
            {t("welcome_title")}
          </h1>
          <p className="mt-5 text-base text-brand-cream/85 leading-relaxed max-w-[34ch]">
            {t("welcome_sub")}
          </p>

          <div className="mt-9 flex flex-col gap-3">
            <Link
              to="/auth?mode=register"
              data-testid="welcome-cta-register"
              className="group inline-flex items-center justify-between px-6 py-4 rounded-2xl bg-brand-cream text-brand-brown font-bold tracking-wider uppercase text-sm transition-transform active:scale-[0.98] hover:bg-white"
            >
              <span>{t("cta_explore")}</span>
              <ArrowRight
                size={18}
                strokeWidth={2}
                className="transition-transform group-hover:translate-x-1"
              />
            </Link>
            <Link
              to="/auth?mode=login"
              data-testid="welcome-cta-login"
              className="inline-flex items-center justify-center py-3 rounded-2xl border border-brand-cream/30 text-brand-cream/90 font-medium tracking-wider uppercase text-xs hover:bg-brand-cream/10 transition-colors"
            >
              {t("cta_login")}
            </Link>
          </div>
        </div>
      </HeroVideo>
    </div>
  );
}
